<template lang="pug">
  div(class="text-center")
    v-menu(offset-y left)
      template(v-slot:activator="{ on }")
        v-btn(icon v-on="on")
          v-icon(large color="#8F96AC") account_circle
      v-list
        v-list-item(v-for="menu in menus" :key="menu.id" :to="menu.url")
          v-list-item-icon(class="mr-4")
            v-icon {{ menu.icon }}
          v-list-item-content
            v-list-item-title {{ menu.title }}
        v-divider
        v-list-item(@click="logout")
          v-list-item-icon(class="mr-4")
            v-icon mdi-logout
          v-list-item-content
            v-list-item-title Выход
</template>
<script>
export default {
  props: {
    /**
     * Роль пользователя вошедшего в систему.
     * @values User, Company, Admin
     */
    userRole: {
      type: String,
      default: '',
      required: true
    }
  },
  data: () => ({
    menus: []
  }),
  watch: {
    userRole: {
      immediate: true,
      handler(value) {
        this.getMenu(value)
      }
    }
  },
  methods: {
    /**
     * Выход из приложения. Будет вызван при выборе пункта меню "Выход" в выпадающем списке.
     */
    logout() {
      this.$store.dispatch('LOGOUT')
    },
    /**
     * Генерация меню в зависимости от роли пользователя.
     * @param {String} role - Роль пользователя вошедшего в систему.
     */
    getMenu(role) {
      const userMenu = [
        {
          id: '372da8d6-8a78-47h2-85ar-a6a7d4bd3a11',
          title: 'Избранное',
          url: '/favorites',
          icon: 'mdi-star'
        },
        {
          id: '388da8d6-8a78-47e2-85be-a6a8d4bd3a83',
          title: 'Мои объявления',
          url: '/profile/adverts',
          icon: 'mdi-format-list-bulleted-square'
        }
      ]
      const companyMenu = [
        {
          id: 'd6f810f9-d707-44ce-9d6c-32cb4025609b',
          title: 'Профиль компании',
          url: '/profile/company',
          icon: 'mdi-briefcase-account-outline'
        },
        {
          id: '0744bf33-4982-4ce1-87f6-eaa2790ab6d7',
          title: 'Комплексы',
          url: '/profile/complexes',
          icon: 'mdi-domain'
        }
      ]
      const adminMenu = []

      switch (role) {
        case 'User':
          this.menus = userMenu
          break
        case 'Company':
          this.menus = companyMenu
          break
        case 'Admin':
          this.menus = adminMenu
          break
        default:
          this.menus = []
      }
    }
  }
}
</script>
